import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { LEVEL_ENTRY, LEVEL_MID, LEVEL_TOP } from './consts';

export const DesignerLevel = PropTypes.oneOf([LEVEL_ENTRY, LEVEL_MID, LEVEL_TOP]);

export const FilterType = PropTypes.oneOf(['checkbox', 'radio']);

export const FilterOption = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
});

export const CurrentUser = PropTypes.shape({
    userId: PropTypes.number,
    isIdentified: PropTypes.bool.isRequired,
    isClientOrCertifiedDesigner: PropTypes.bool.isRequired,
});

export const GroupedFilterOption = PropTypes.shape({
    parentOption: FilterOption,
    childOptions: PropTypes.arrayOf(FilterOption),
});

export const FilterGroup = PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.oneOfType([
        MobxPropTypes.observableArray,
        PropTypes.arrayOf(FilterOption),
        PropTypes.arrayOf(GroupedFilterOption),
    ]).isRequired,
});

export const Urls = PropTypes.shape({
    urls: PropTypes.shape({
        rootPath: PropTypes.string.isRequired,
    }),
});

export const Design = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    imageSources: PropTypes.shape({
        smallCrop: PropTypes.string.isRequired,
        largeCrop: PropTypes.string.isRequired,
        original: PropTypes.string.isRequired,
    }).isRequired,
});

export const Designs = PropTypes.arrayOf(Design);

export const Creator = PropTypes.shape({
    userId: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    designerLevel: PropTypes.string.isRequired,
    reviewCount: PropTypes.number.isRequired,
    reviewRating: PropTypes.number.isRequired,
    expertiseCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
    designs: Designs.isRequired,
    flags: PropTypes.arrayOf(PropTypes.string),
    isAvailable: PropTypes.bool,
    isOnline: PropTypes.bool,
});

export const Creators = PropTypes.arrayOf(Creator);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/propTypes.js